import React, { useEffect, useContext, useState }  from 'react'
import { View, StyleSheet, ScrollView, FlatList } from 'react-native'
import { Button, Text, Card, CheckBox } from '@ui-kitten/components'
import { UserContext } from '../../global/UserProvider'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { WhatsAppButton } from '../../components/WhatsAppButton'
import { reportFirestoreOnlyWriterUsage } from '../../global/analytics/firestoreOnlyWriterUsage'

export default function MarketingListDetailScreen( { navigation, route } ) {
  const { t } = useTranslation()
  const [context, setContext] = useContext(UserContext)
  const [marketingList, setMarketingList] = useState(route.params.marketingList)

  useEffect(() => {
    marketingList.ref.onSnapshot((querySnapshot) => {
      var newMarketingList = querySnapshot.data()
      newMarketingList.id = querySnapshot.id
      newMarketingList.ref = querySnapshot.ref
      setMarketingList(newMarketingList)
    })
  }, [])

  const renderItem = ({item, index}) => (
    <Card style={{padding: 10, marginBottom: 5}}>
      <CheckBox 
        checked={item.isDone}
        onChange={(isChecked) => {
          updateCheckbox(item, index, isChecked)
        }}  
        style={{marginBottom: 5}}
      >
        {item.displayName + ', ' + item.phoneNumber}
      </CheckBox>  
      { Object.entries(item.products).map(([key, product]) => (
        <View key={key} style={{flexDirection: 'row', alignItems: 'center'}}>
          <Text style={{flex: 5}}>{product.name}</Text>
          <Text style={{flex: 1}}>{product.totalChecks}</Text>
          <Text style={{flex: 1}}>{product.totalQuantity}</Text>
        </View>
      ))}
      <WhatsAppButton phone={item.phoneNumber} style={{marginTop: 5}}>
        {t('marketingLists.writeOnWhatsapp')}
      </WhatsAppButton>
    </Card>
  )

  const updateCheckbox = (item, index, isChecked) => {
    var newData = [...marketingList.data]
    var newItem = {...newData[index]}
    newItem['isDone'] = isChecked
    newData[index] = newItem
    reportFirestoreOnlyWriterUsage('updateMarketingListItem', context?.user?.organizationId)
    marketingList.ref.update({data: newData})
  }

  const toggleListDone = () => {
    reportFirestoreOnlyWriterUsage('toggleMarketingListDone', context?.user?.organizationId)
    return marketingList.ref.update({isDone: !marketingList.isDone})
  }

  return (
    <ScrollView style={{padding: 20}}>
      <Text category='label' style={{marginBottom: 5}}>{marketingList.detail + ', ' + format(marketingList.date.toDate(), 'd MMM y HH:MM')}</Text>
      <Text category='label' style={{marginBottom: 10}}>{t('marketingLists.status') + ': ' + (marketingList.isDone ? t('marketingLists.completed') : t('marketingLists.notCompleted'))}</Text>
      <Button style={{marginBottom: 10}} onPress={toggleListDone}>{t('marketingLists.complete')}</Button>
      <FlatList
        data={marketingList.data}
        renderItem={renderItem}
      />
    </ScrollView>
  )
}
  

const styles = StyleSheet.create({
  
})